module.exports = {
      id: "stories-usage",
      viewBox: "0 0 33 27.835",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#stories",
      toString: function () {
        return this.url;
      }
    }